const $ = window.jQuery;
const HG = window.HG || (window.HG = {});

import GQCustomQuestions from './components/custom_questions';

const gaCategory = 'Post Job';
const gaAction = `${gaCategory} -`;
const gaLabel = gaAction;

import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import PostcodeAutocomplete from './components/postcode-autocomplete';

class GetQuotesForm {
  init() {
    jQuery(document).ready(() => {
      const $multiStepForm = $('#autocomplete_form_step1');
      let options = {};

      if ($multiStepForm.length > 0) {
        options = JSON.parse($multiStepForm.attr('data-options'));
      }

            // get options from element
      const cq = new GQCustomQuestions(options);
      cq.init();

      // react postcode autocomplete
      const postcodeAutocompleteEl = document.getElementById('postcodeAutocomplete');

      // init react elements
      if (postcodeAutocompleteEl) {
          ReactDOM.render(
            <PostcodeAutocomplete
              classPrefix="gq-postcode"
              GACategory={gaCategory}
              GAAction={`${gaAction} Select Postcode Autocomplete`}
              GALabel={`${gaLabel} Select Postcode Autocomplete`}
            />,
            postcodeAutocomplete
        );
      }
    });
  }
}

export default GetQuotesForm;

HG.GetQuotesForm = new GetQuotesForm();
HG.GetQuotesForm.init();



// WEBPACK FOOTER //
// ./module_get_quotes/scripts/main.js